// Util
import { DateUtil } from '@/utils/dateutil';

// API
import connectionApi from '@/api/connectionApi';
import { fetchOnce } from '@/store/utils/fetchOnce';

// Others
import { db } from '@/config/firebase';
import config from '@/config/env-constants';
import _ from 'lodash';

export default {
	namespace: true,

	state: {
		connections: {},
		currConnection: {},
		connectionsLoaded: false,
	},

	mutations: {
		SET_ALL_CONNECTIONS(state, connections) {
			state.connections = connections
		},
		SET_CURR_CONNECTION(state, connection) {
			state.currConnection = connection
		},
		SET_CONNECTIONS_LOADED(state, val) {
			state.connectionsLoaded = val;
		},
	},

	actions: {
		setAllConnections(vuexContext, connections) {
			vuexContext.commit('SET_ALL_CONNECTIONS', connections);
		},

		fetchConnectionsIfNeeded({ state, getters, commit }, payload = {}) {
			if (state.connectionsLoaded) return Promise.resolve();
			return fetchOnce('connections', () => {
				let currUserId = payload.currUserId || getters.loggedUser.id;
				let view = payload.view || (getters.isSuperAdmin ? config.view.ADMIN : config.view.COMPANY);
				let filterBy = payload.filterBy || {
					companyId: getters.loggedUserCompany.id,
					companyAccess: getters.loggedUser.companyAccess,
				};

				return connectionApi.getConnections(filterBy, view, currUserId).then(({ data }) => {
					if (data.isSuccess) {
						commit('SET_ALL_CONNECTIONS', data.connections);
						commit('SET_CONNECTIONS_LOADED', true);
					}
					return data;
				});
			});
		},
		updateAllConnections(vuexContext, newConnections) {
			let connections = vuexContext.getters.connections;

			_.forEach(newConnections, (value, key) => {
				connections[key] = value;
			});

			vuexContext.commit('SET_ALL_CONNECTIONS', connections);
		},

		async addConnection({ rootState }, param) {
			let currUserId = rootState.auth.email;
			let newConnection = {
				company: param.company,
				companyId: param.companyId,
				connectedCompany: param.connectedCompany,
				connectedCompanyId: param.connectedCompanyId,
				connections: param.connections,
				storageLocations: param.storageLocations,
				isActive: param.isActive,
				notes: param.notes,
				others: param.others,
				dateCreated: DateUtil.getCurrentTimestamp(),
				createdBy: currUserId,
				dateUpdated: DateUtil.getCurrentTimestamp(),
				updatedBy: currUserId
			}

			return db.collection("connections").add(newConnection)
				.then((docRef) => {
					newConnection.id = docRef.id;
					return {
						isSuccess: true,
						data: newConnection
					};
				}).catch((error) => {
					return {
						isSuccess: false,
						data: error
					};
				});
		},

		async updateConnection({ rootState }, param) {
			let currUserId = rootState.auth.email;
			let selConnection = {
				id: param.id,
				company: param.company,
				companyId: param.companyId,
				connectedCompany: param.connectedCompany,
				connectedCompanyId: param.connectedCompanyId,
				connections: param.connections,
				storageLocations: param.storageLocations,
				isActive: param.isActive,
				notes: param.notes,
				others: param.others,
				dateCreated: param.dateCreated,
				createdBy: param.updatedBy,
				dateUpdated: DateUtil.getCurrentTimestamp(),
				updatedBy: currUserId
			}

			return db.collection("connections").doc(param.id).set(selConnection)
				.then(() => {
					return {
						isSuccess: true,
						data: selConnection
					};
				}).catch((error) => {
					return {
						isSuccess: false,
						data: error
					};
				});
		}
	},

	getters: {
		connections(state) {
			if (!_.isEmpty(state.connections)) {
				return state.connections;
			}
			return {};
		},
		currConnection(state) {
			if (!_.isEmpty(state.currConnection)) {
				return state.currConnection;
			}
			return {};
		}
	}
}
